<template>
  <div style="padding: 10px; background: #f4f3ef">
    <div class="box box-primary">
      <form class="form-horizontal">
        <div class="box-body">
          <div class="col-md-12">
            <div class="row">
              <div class="col-sm-12 col-md-10 col-lg-8">
                <div class="form-group">
                  <label
                    class="col-sm-4 col-md-4 col-lg-4 control-label required"
                    >{{ $t("apartment.apartment_code") }}</label
                  >
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <input
                      :disabled="apartmentInfoData.id !== 0"
                      v-model="apartmentInfoData.apartmentCode"
                      type="text"
                      class="form-control"
                      :placeholder="$t('apartment.apartment_code')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-10 col-lg-8">
                <div class="form-group">
                  <label
                    class="col-sm-4 col-md-4 col-lg-4 control-label required"
                    >{{ $t("apartment.size") }}</label
                  >
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <input
                      :disabled="apartmentInfoData.id !== 0"
                      v-model="apartmentInfoData.size"
                      type="text"
                      class="form-control"
                      :placeholder="$t('apartment.size')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-10 col-lg-8">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label">{{
                    $t("apartmentGroup.title")
                  }}</label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <!-- <input
                      v-model="apartmentInfoData.apartmentGroup"
                      type="text"
                      class="form-control"
                      :placeholder="$t('apartmentGroup.title')"
                    /> -->
                    <v-select
                      class="clear"
                      :options="apartmentGroupList"
                      :reduce="data => data.value"
                      :getOptionLabel="option => $t(option.text)"
                      v-model="apartmentInfoData.apartmentGroup"
                      :placeholder="$t('apartmentGroup.title')"
                    >
                      <template v-slot:option="option">
                        {{ option.text }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-10 col-lg-8">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label">{{
                    $t("apartmentType.title")
                  }}</label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <!-- <input
                      v-model="apartmentInfoData.apartmentType"
                      type="text"
                      class="form-control"
                      :placeholder="$t('apartmentType.title')"
                    /> -->
                    <v-select
                      class="clear"
                      :options="apartmentTypeList"
                      :reduce="data => data.value"
                      :getOptionLabel="option => $t(option.text)"
                      v-model="apartmentInfoData.apartmentType"
                      :placeholder="$t('apartmentType.title')"
                      @option:selected="
                        onSelectApartmentType(apartmentInfoData.apartmentType)
                      "
                    >
                      <template v-slot:option="option">
                        {{ option.text }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="apartmentInfoData.apartmentType">
              <div class="col-sm-12 col-md-10 col-lg-8">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label">{{
                    $t("apartmentType.bedrooms")
                  }}</label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <span
                      type="text"
                      class="form-control disable-input-background"
                      :placeholder="$t('apartmentType.bedrooms')"
                      >{{
                        apartmentTypeData && apartmentTypeData.bedrooms
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="apartmentInfoData.apartmentType">
              <div class="col-sm-12 col-md-10 col-lg-8">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label">{{
                    $t("apartmentType.bathroom")
                  }}</label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <span
                      type="text"
                      class="form-control disable-input-background"
                      :placeholder="$t('apartmentType.bathroom')"
                      >{{
                        apartmentTypeData && apartmentTypeData.bathroom
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-10 col-lg-8">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label"></label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        id="exampleCheck2"
                        v-model="apartmentInfoData.leasebackService"
                      />
                      <label class="form-check-label" for="exampleCheck2">{{
                        $t("apartment.leasebackService")
                      }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-10 col-lg-8">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label">{{
                    $t("apartment.other_details")
                  }}</label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <textarea
                      class="form-control"
                      name=""
                      id=""
                      cols="30"
                      rows="2"
                      v-model="apartmentInfoData.other_details"
                      :placeholder="$t('apartment.other_details')"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-10 col-lg-8">
                <div class="form-group">
                  <label class="col-sm-4 col-md-4 col-lg-4 control-label">{{
                    $t("common.description")
                  }}</label>
                  <div class="col-sm-8 col-md-8 col-lg-8">
                    <textarea
                      class="form-control"
                      name=""
                      id=""
                      cols="30"
                      rows="4"
                      v-model="apartmentInfoData.description"
                      :placeholder="$t('common.description')"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="onApartmentCancel"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            v-if="
              has_perm('update_apartment') ||
                GET_ACCOUNT_DATA.id == 1 ||
                has_perm('create_apartment')
            "
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="onSaveApartmentInfo"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </form>
    </div>
    <!-- <div class="box box-success" v-if="apartmentInfoData.id">
      <div class="box-header with-border">
        <span class="box-title">{{ $t("banner.image") }}</span>
      </div>
      <div class="box-body">
        <div class="col-md-12">
          <div class="row">
            <div class="form-group">
              <button
                type="button"
                class="btn btn-labeled btn-primary pull-right"
                @click="onAddImg"
                style="margin-right: 5px;"
              >
                <span class="btn-label"> <i class="fa fa-plus"></i> </span>
                {{ $t("common.addnew") }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12" style="margin-top: 15px">
          <apartment-map-img />
        </div>
      </div>
    </div> -->
    <apartment-map-img v-if="apartmentInfoData.id !== 0" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ApartmentMapImg from "./ApartmentMapImg";
import utils from "@/lib/utils";

export default {
  components: {
    ApartmentMapImg
  },
  props: {
    apartmentId: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  data: () => ({
    isLoading: false,
    apartmentInfoData: {
      id: 0,
      size: null,
      apartmentCode: null,
      apartmentType: null,
      apartmentGroup: null,
      description: null,
      other_details: null,
      status: 1,
      leasebackService: true
    },
    apartmentTypeData: null,
    apartmentTypeList: [],
    apartmentGroupList: []
  }),
  watch: {
    apartmentId: function() {
      this.apartmentInfoData.id = this.apartmentId;
    },
    APARTMENT_DETAIL_DATA: function() {
      this.apartmentInfoData.id = this.APARTMENT_DETAIL_DATA.id;
      this.apartmentInfoData.size = this.APARTMENT_DETAIL_DATA.size;
      this.apartmentInfoData.apartmentCode = this.APARTMENT_DETAIL_DATA.apartment_code;
      this.apartmentInfoData.apartmentType = this.APARTMENT_DETAIL_DATA.apt_type;
      this.apartmentInfoData.apartmentGroup = this.APARTMENT_DETAIL_DATA.apartment_group;
      this.apartmentInfoData.status = this.APARTMENT_DETAIL_DATA.status;
      this.onSelectApartmentType(this.APARTMENT_DETAIL_DATA.apt_type);
      this.apartmentInfoData.other_details = this.APARTMENT_DETAIL_DATA.other_details;
      this.apartmentInfoData.description = this.APARTMENT_DETAIL_DATA.description;
      this.apartmentInfoData.leasebackService = this.APARTMENT_DETAIL_DATA.leaseback_service
    },
    GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA: function() {
      this.apartmentTypeList = []
      let data = this.GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA;
      data.forEach(value => {
        let item = {
          value: value.id,
          text: value.name,
          adults: value.adults,
          children: value.children,
          bathroom: value.bathroom,
          bedrooms: value.bedrooms
        };
        this.apartmentTypeList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "APARTMENT_DETAIL_DATA",
      "GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA"
    ])
  },
  created() {
    if (this.apartmentId !== 0) {
      this.apartmentInfoData.id = this.apartmentId;
    }
    //
    this.getApartmentTypeList();
    this.getApartmentGroupList();
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onApartmentCancel: function() {
      this.$router.push({
        name: "ApartmentList"
      });
    },
    onSaveApartmentInfo: function() {
      if (utils.isEmptyString(this.apartmentInfoData.size)) {
        //
        this.ON_SHOW_TOAST({
          message: this.$t("apartment.size"),
          styleType: "danger"
        });
      } else if (
        utils.isEmptyString(this.apartmentInfoData.apartmentCode)
      ) {
        //
        this.ON_SHOW_TOAST({
          message: this.$t("apartment.apartment_code"),
          styleType: "danger"
        });
      } else {
        let data = {
          id: this.apartmentInfoData.id,
          apartment_code: this.apartmentInfoData.apartmentCode,
          size: this.apartmentInfoData.size,
          apartment_group: this.apartmentInfoData.apartmentGroup,
          apt_type_id: this.apartmentInfoData.apartmentType,
          other_details: this.apartmentInfoData.other_details,
          description: this.apartmentInfoData.description,
          status: this.apartmentInfoData.status,
          updateApartmentExtraInfo: true,
          leaseback_service: this.apartmentInfoData.leasebackService
        };
        if (this.apartmentInfoData.id === 0) {
          this.ADD_APARTMENT({ data: data }).then(
            function() {
              this.$router.push({ name: "ApartmentList" });
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
        } else {
          this.UPDATE_APARTMENT({ id: this.apartmentInfoData.id, data: data }).then(
            function() {
              this.$router.push({ name: "ApartmentList" });
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
        }
      }
    },
    getApartmentTypeList: function() {
      this.isLoading = true;
      this.apartmentTypeList = [];
      this.GET_APARTMENT_TYPE_LIST()
        .then(function() {
          this.isLoading = false;
        }.bind(this))
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onSelectApartmentType: function(value) {
      let index = this.apartmentTypeList.findIndex(x => x.value === value);
      this.apartmentTypeData =
        index !== -1 ? this.apartmentTypeList[index] : null;
    },
    getApartmentGroupList: function() {
      this.apartmentGroupList = [];
      this.GET_APARTMENT_GROUP_LIST().then(
        function(res) {
          let data = res;
          data.forEach(value => {
            let item = {
              value: value.id,
              text: value.name
            };
            this.apartmentGroupList.push(item);
          });
        }.bind(this)
      )
      .catch(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    onAddImg: function() {},
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "ADD_APARTMENT",
      "UPDATE_APARTMENT",
      "GET_APARTMENT_TYPE_LIST",
      "GET_APARTMENT_GROUP_LIST"
    ])
  }
};
</script>
<style scoped>
.disable-input-background {
  background: #e4e7e8;
}
label.required:not(:empty):after,
.field-header.required:after {
  content: " *";
  color: red;
  position: absolute;
  right: 5px;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentInfoWithExtraInfo.vue